module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sofia-samardich-70f36d1d5903db182db2137a6f2e5153.jpg";